import React from 'react';
import { Check, Copy, Eye, EyeOff, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const SuccessScreen = ({ success, showPin, setShowPin, copied, copyToClipboard, navigate }) => (
  <div className="min-h-screen bg-slate-50 py-12">
    <div className="max-w-2xl mx-auto px-4">
      <Card>
        <CardContent className="pt-8 pb-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-emerald-600" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-2">Denúncia Submetida com Sucesso</h1>
            <p className="text-slate-600">Guarde as informações abaixo para acompanhar a sua denúncia.</p>
          </div>

          <div className="bg-slate-100 rounded-lg p-6 mb-6">
            <div className="mb-4">
              <Label className="text-sm text-slate-500">Código de Seguimento</Label>
              <div className="flex items-center gap-2 mt-1">
                <code className="text-2xl font-bold text-slate-900 tracking-wider" data-testid="tracking-code">
                  {success.tracking_code}
                </code>
                <Button variant="ghost" size="sm" onClick={() => copyToClipboard(success.tracking_code)}>
                  <Copy className="w-4 h-4" />
                </Button>
              </div>
            </div>

            <div>
              <Label className="text-sm text-slate-500">PIN de Acesso</Label>
              <div className="flex items-center gap-2 mt-1">
                <code className="text-2xl font-bold text-slate-900 tracking-wider" data-testid="pin-code">
                  {showPin ? success.pin : '••••••••'}
                </code>
                <Button variant="ghost" size="sm" onClick={() => setShowPin(!showPin)}>
                  {showPin ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </Button>
                <Button variant="ghost" size="sm" onClick={() => copyToClipboard(success.pin)}>
                  <Copy className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>

          {copied && (
            <Alert className="mb-4 bg-emerald-50 border-emerald-200">
              <AlertDescription className="text-emerald-700">
                Copiado para a área de transferência
              </AlertDescription>
            </Alert>
          )}

          <Alert className="mb-6 bg-amber-50 border-amber-200">
            <AlertCircle className="w-4 h-4 text-amber-600" />
            <AlertDescription className="text-amber-700">
              <strong>Importante:</strong> Guarde estes dados num local seguro.
              Sem eles, não poderá acompanhar a sua denúncia.
            </AlertDescription>
          </Alert>

          <div className="bg-slate-50 rounded-lg p-4 mb-6">
            <h3 className="font-medium text-slate-900 mb-2">Próximos Passos (Lei 93/2021)</h3>
            <ul className="text-sm text-slate-600 space-y-1">
              <li>• Confirmação de receção formal: até 7 dias úteis</li>
              <li>• Feedback sobre seguimento: até 3 meses</li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button className="flex-1" onClick={() => navigate('/seguimento')}>
              Acompanhar Denúncia
            </Button>
            <Button variant="outline" className="flex-1" onClick={() => navigate('/')}>
              Voltar ao Início
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);
